import React from 'react';
import { motion } from 'framer-motion';
import profileImage from '../assets/dein-portrait.jpg'; // Dein Portraitfoto

const Hero = () => {
  const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.2, }}};
  const itemVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" }}};

  return (
    <section className="hero-agency">
      <div className="container">
        <motion.div className="hero-text-content" variants={containerVariants} initial="hidden" animate="visible">
          <motion.h1 variants={itemVariants}>Digitales Handwerk für <span>Ihren Erfolg.</span></motion.h1>
          <motion.p variants={itemVariants}>Ich bin Tobias Grimm – Ihr persönlicher Partner für professionelles Webdesign und Entwicklung. Gemeinsam schaffen wir Webseiten, die nicht nur gut aussehen, sondern auch funktionieren.</motion.p>
          <motion.div variants={itemVariants}><a href="#kontakt" className="cta-button">Projekt starten</a></motion.div>
        </motion.div>
        <motion.div className="hero-image-content" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}>
          <img src={profileImage} alt="Portrait von Tobias Grimm, Webdesigner" />
        </motion.div>
      </div>
    </section>
  );
};
export default Hero;